var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3698d4;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "thoughtriver-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "thoughtRiverLogo"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.57,60.27a67.12,67.12,0,0,0-15-28.79L44.22,3.37C52,15.24,53.87,27.91,53.33,35.46,53.33,35.46,52.92,42.54,45.57,60.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "mid-square",
    className: "cls-2",
    d: "M39.3,7.42,27.44,31.89l1.14,1.28A67.06,67.06,0,0,1,41.39,55.28L40.25,59.6S32.29,39,15.71,26.29L33,0A65.1,65.1,0,0,1,39.3,7.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.2,26.9l2,1.48c10.45,8,17.39,19.42,21,26.29L34,58.31C30.94,53,23.33,37.82,0,26.43L19.69,1.21a68.68,68.68,0,0,1,6.13,5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMini);
export default __webpack_public_path__ + "static/media/logo-mini.96dc16fc271f75ac5b3e48ca3af09ace.svg";
export { ForwardRef as ReactComponent };